export default "__VITE_ASSET__mIwSHBdt__"